import PropTypes from 'prop-types';
import { Loader } from 'ypf-pas-general-ui-components';
import { useState, createContext } from 'react';

const LoaderContext = createContext();

export default LoaderContext;

export function LoaderProvider({ children }) {
  const [loader, setLoader] = useState(false);

  return (
    <LoaderContext.Provider
      value={{
        loader,
        setLoader
      }}
    >
      <>
        {children}
        {loader && (
          <div className="loader">
            <Loader show={loader} text="CARGANDO ..." />
          </div>
        )}
      </>
    </LoaderContext.Provider>
  );
}

LoaderProvider.propTypes = {
  children: PropTypes.node.isRequired
};
